import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexGrow: '1',
    flexDirection: 'column',
    marginTop: '1rem',
    paddingTop: '1rem',
    paddingBottom: '0.5rem'
  },

  inputClass: {
    backgroundColor: '#F5F6F8',

    '&::placeholder': {
      color: '#888888 !important'
    }
  },

  inputRoot: {
    marginTop: '2rem',
    marginBottom: '0.75rem',
    maxWidth: '300px',
    height: ({ modal }) => (modal ? 'unset !important' : 'inherit')
  },

  noTags: {
    display: 'inline-block',
    border: '1px solid #C6C6C6',
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '4px 8px',
    background: '#F5F6F8',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    marginBottom: '1rem'
  },

  tagList: {
    zIndex: ({ modal }) => (modal ? '1' : '0'),
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: '1rem',

    '& > div': {
      marginTop: 2,
      marginBottom: 2
    },

    '& > :not(:last-child)': {
      marginRight: '8px'
    }
  }
}))

export default useStyles
